import React from 'react';
import { Props } from 'react-select';
import classNames from 'classnames';

import SelectWidget, {
  SelectFieldCustomClasses,
} from 'components/UI/Form/Widget/SelectWidget/SelectWidget';

import styles from './CartSelect.module.scss';

type SelectWidgetType = Props & {
  classes?: Partial<SelectFieldCustomClasses>;
};

export default function CartSelect({
  classes,
  ...props
}: SelectWidgetType): JSX.Element {
  return (
    <SelectWidget
      classes={{
        control: classNames(styles.selectControl, classes?.control),
        menu: classNames(styles.menu, classes?.menu),
        menuPortal: classNames(styles.selectMenuPortal, classes?.menuPortal),
        option: classNames(styles.selectOption, classes?.option),
        placeholder: classNames(styles.selectPlaceholder, classes?.placeholder),
        valueContainer: classNames(
          styles.selectValueContainer,
          classes?.valueContainer
        ),
        dropdownIndicator: classes?.dropdownIndicator,
        menuList: classes?.menuList,
        singleValue: classes?.singleValue,
      }}
      {...props}
    />
  );
}
